<template>
  <div class="dashboard-toggle form-check form-switch m-0">
    <input
      class="form-check-input"
      type="checkbox"
      role="switch"
      :checked="show"
      @change="handleChange"
    />
    <label class="form-check-label">
      Dashboard View
    </label>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex';

export default {
  name: "DashboardToggle",
  data() {
    return {
      show: false,
    }
  },
  computed: {
    ...mapGetters("user", ["userDashboardView"])
  },
  created() {
    this.show = this.userDashboardView;
  },
  methods: {
    handleChange() {
      this.show = !this.show;
      this.$emit('showDashboard', this.show);
      this.$store.commit("user/setUserDashboardView", this.show);
    }
  }
};
</script>

<style lang="scss">

</style>